import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { InfosUser } from '@classes/auth/infosUser';
import { MenuAdmin, NavLinks } from '@classes/navlinks/navlinks';
import { UserList } from '@classes/user/userlist';
import {
  faSearch,
  faTimes,
  faPlus,
  faUserPlus,
  faUsers,
  faShoppingCart,
  faVideo,
  faBookOpen,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { UserService } from '@services/user/user.service';
import { AddUsersComponent } from '../add-users/add-users.component';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
})
export class AdminHomeComponent implements OnInit {
  faSearch = faSearch;
  faTimes = faTimes;
  faPlus = faPlus;
  faBook = faBookOpen;
  faUserPlus = faUserPlus;
  faUsers = faUsers;
  faShoppingCart = faShoppingCart;
  faVideo = faVideo;
  faEye = faEye;

  userConnected: InfosUser;
  dataSource: MatTableDataSource<UserList>;

  show = false;

  menuSuperAdmin: MenuAdmin[] = [
    {
      appName: 'Customers',
      description: 'Customer management',
      icon: 'faShoppingCart',
      iconType: 'faIcon',
      hide: true,
      url: '/admin/clients',
    },
    {
      appName: 'Users',
      description: 'User management',
      icon: 'faUsers',
      iconType: 'faIcon',
      hide: false,
      url: '/admin/users',
    },
    {
      appName: 'Logs',
      description: 'Log monitoring',
      icon: 'faBook',
      iconType: 'faIcon',
      hide: true,
      url: '/admin/logs',
    },
    {
      appName: 'Cameras',
      description: 'Camera management',
      icon: 'faVideo',
      iconType: 'faIcon',
      hide: false,
      url: '/admin/Caméras',
    },
    {
      appName: 'ANPR Licenses',
      description: 'ANPR Licenses management',
      icon: 'faEye',
      iconType: 'faIcon',
      hide: true,
      url: '/admin/ANPR',
    },
  ];

  menu: MenuAdmin[] = [];

  constructor(
    public router: Router,
    private userService: UserService,
    private dialog: MatDialog,
    private dataService: DataService,
    private authSrv: AuthService
  ) {}

  ngOnInit(): void {
    this.userConnected = this.authSrv.getDecodedToken();

    if (!this.userConnected.role.includes('Administration$SuperAdmin')) {
      this.menu = [...this.menuSuperAdmin].filter(
        (menu) => menu.appName !== 'Customers'
      );
    } else {
      this.menu = [...this.menuSuperAdmin];
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  showElement(): void {
    setTimeout(() => {
      this.show = true;
    }, 150);
  }

  getIcon(icon: string): object {
    let faicon: object;
    switch (icon) {
      case 'faShoppingCart':
        faicon = this.faShoppingCart;
        break;
      case 'faUsers':
        faicon = this.faUsers;
        break;
      case 'faVideo':
        faicon = this.faVideo;
        break;
      case 'faBook':
        faicon = this.faBook;
        break;
      case 'faEye':
        faicon = this.faEye;
        break;

      default:
        break;
    }
    return faicon;
  }
}
